'use strict';

const { get, isEmpty } = require('lodash');
const toaster = require('richemont/components/toaster');

const $cache = {
    body: $('body'),
};

const initAddToCartSuccessCarousel = () => {
    $cache.$recommendedProductCarousel = $cache.body.find('.frequently-bought-together');

    if (!$cache.$recommendedProductCarousel.hasClass('slick-initialized')) {
        $cache.$recommendedProductCarousel.slick({
            dots: false,
            arrows: true,
            infinite: false,
            speed: 200,
            touchThreshold: 100,
            slidesToShow: 1.8,
            slidesToScroll: 1,
            nextArrow: '<button type="button" class="slick-next"><i class="icon icon-arrow-forward icon-size-xl"></i></button>',
            prevArrow: '<button type="button" class="slick-prev"><i class="icon icon-arrow-back icon-size-xl"></i></button>',
            responsive: [
                {
                    breakpoint: window.app.grid.lg,
                    settings: {
                        slidesToShow: 2.4,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: window.app.grid.md,
                    settings: {
                        slidesToShow: 1.2,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    }
};

const closeToaster = ($toaster, atbLabel) => {
    const $closeBtn = $toaster.find('.close-toaster');

    $closeBtn.on('click', () => {
        $toaster.addClass('closing');

        setTimeout(() => {
            $toaster.addClass('d-none').removeClass('closing toaster-animate');
        }, window.brandSettings.toasterCloseDelay || 0);
        $cache.body.find('.toaster-backdrop').remove();

        $cache.body.find('.frequently-bought-together .product').each((idx, product) => {
            const $tile = $(product);
            $tile.find('.atb-msg-container').addClass('d-none');
            $tile.find('.add-to-cart-global span').text(atbLabel);
        });
    });

    toaster.closeToasterEvents($toaster);
};

const handleProductRecommendationCarousel = (carouselAddToCartBtnPid, details) => {
    const $successToaster = $('.product-add-to-cart-success-toaster');
    $successToaster.spinner().start();

    const { displayRecosControllerUrl } = details;
    if (!isEmpty(displayRecosControllerUrl)) {
        $.ajax({
            url: displayRecosControllerUrl,
            method: 'GET',
        })
            .then((data) => {
                if (data.success) {
                    $successToaster.removeClass('d-none');
                    $successToaster.find('.add-to-cart-success-toaster-body').append(data.template);

                    initAddToCartSuccessCarousel();
                    $cache.body.find('.frequently-bought-together .product').each((idx, product) => {
                        const $tile = $(product);
                        const $atb = $tile.find('.add-to-cart-global');
                        const item = get(data, 'cart.items', []).find((i) => i.id === $tile.attr('data-pid'));
                        if (item && get(item, 'quantity') === get(item, 'quantityOptions.maxOrderQuantity')) {
                            $atb.attr('disabled', true);
                        }
                        if ($tile.attr('data-pid') === carouselAddToCartBtnPid) {
                            $tile.find('.atb-msg-container').removeClass('d-none');
                            $atb.find('span').text(get(details, 'addOneMoreLabel', ''));
                        }
                    });
                }
                $successToaster.spinner().stop();
            })
            .catch(() => {
                $successToaster.spinner().stop();
            });
    }
};

/**
 * Init Toaster
 */
const initSuccessToaster = () => {
    let carouselAddToCartBtnPid = '';

    $cache.body.on('cart:addSuccessToaster', (e, data) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        if ($('.search-results').length > 0) {
            return;
        }

        const isError = !!get(data, 'error');
        const successToaster = get(data, 'addedProductToaster', {});
        if (!isEmpty(successToaster) && !isEmpty(successToaster.template) && !isError) {
            const $successToaster = $('.product-add-to-cart-success-toaster');
            $successToaster.removeClass('d-none');

            if (window.brandID === 'AAL') {
                setTimeout(function () {
                    $successToaster.addClass('toaster-animate');
                }, 0);
            }
            $successToaster.find('.add-to-cart-success-toaster-body').empty().append(successToaster.template);

            if (!$cache.body.find('.toaster-backdrop').length) {
                if (!$('.wishlist-page-wrapper').length) {
                    $cache.body.append('<div class="toaster-backdrop modal-backdrop fade show"></div>');
                }
            }

            closeToaster($successToaster, get(successToaster, 'details.atbLabel', ''));

            $cache.body.on('product:beforeAddToCart', (event, button) => {
                carouselAddToCartBtnPid = $(button).attr('data-pid');
            });
            $cache.body.on('updateAddToCartFormData', (_, form) => {
                form.pid = carouselAddToCartBtnPid;
            });
            if (get(successToaster, 'details.shouldDisplayRecos')) {
                handleProductRecommendationCarousel(carouselAddToCartBtnPid, get(successToaster, 'details', {}));
            }
        }
    });

    $cache.body.on('removeProduct:success', function () {
        $('.product-add-to-cart-success-toaster .close-toaster').click();
    });
};

const initWishlistToaster = () => {
    if ($('.js-wishlist-with-toaster').length === 0) {
        return;
    }
    const $removeFromWishlistModal = $('.remove-from-wishlist-modal');
    const $addedToWishlistModal = $('.successful-add-to-wishlist-modal');
    const $document = $(document);

    $('.remove-from-wishlist').on('click', function () {
        toaster.openToaster($removeFromWishlistModal);
        toaster.closeToasterEvents($removeFromWishlistModal);
    });

    $('.remove-from-wishlist-modal .close, .remove-from-wishlist-modal .cancel-btn').on('click', function () {
        toaster.closeToaster($removeFromWishlistModal);
    });

    $document.on('toasterWishlist:close', function () {
        toaster.closeToaster($removeFromWishlistModal);
    });

    $document.on('toasterWishlist:open', function () {
        toaster.openToaster($addedToWishlistModal);
        toaster.closeToasterEvents($addedToWishlistModal);
    });

    $('.close', $addedToWishlistModal).on('click', function () {
        toaster.closeToaster($addedToWishlistModal);
    });
};

module.exports = {
    methods: {
        initSuccessToaster,
        initWishlistToaster,
    },
};
